// extracted by mini-css-extract-plugin
export default {"nugget":"Nugget_nugget__gfnco","imageContainer":"Nugget_imageContainer__8yVEx","image":"Nugget_image__RJqzb"};